import React from 'react';
import { Box } from '@mui/material';
import { LoadingSpinner } from 'cprime-foundational-components';

const AppBootstrapSpinner = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#F8F8F9'
            }}
        >
            <LoadingSpinner />
        </Box>
    );
};

export default AppBootstrapSpinner;